import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import MUIList from '@material-ui/core/List';
import style from './List.style';
import { jsx as ___EmotionJSX } from "@emotion/core";

const List = ({
  children,
  component,
  className,
  compact,
  role
}) => ___EmotionJSX(MUIList, {
  component: component,
  role: role,
  css: /*#__PURE__*/_css([style.list.base, compact && style.list.compact], ";label:List;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xpc3QvTGlzdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFTSSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9MaXN0L0xpc3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBNVUlMaXN0IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlL0xpc3QnO1xuaW1wb3J0IHN0eWxlIGZyb20gJy4vTGlzdC5zdHlsZSc7XG5cbmNvbnN0IExpc3QgPSAoeyBjaGlsZHJlbiwgY29tcG9uZW50LCBjbGFzc05hbWUsIGNvbXBhY3QsIHJvbGUgfSkgPT4gKFxuICA8TVVJTGlzdFxuICAgIGNvbXBvbmVudD17Y29tcG9uZW50fVxuICAgIHJvbGU9e3JvbGV9XG4gICAgY3NzPXtbc3R5bGUubGlzdC5iYXNlLCBjb21wYWN0ICYmIHN0eWxlLmxpc3QuY29tcGFjdF19XG4gICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gID5cbiAgICB7Y2hpbGRyZW59XG4gIDwvTVVJTGlzdD5cbik7XG5cbkxpc3QuZGVmYXVsdFByb3BzID0ge1xuICBjb21wb25lbnQ6ICd1bCcsXG4gIHJvbGU6ICcnLFxuICBjaGlsZHJlbjogW10sXG4gIGNsYXNzTmFtZTogdW5kZWZpbmVkLFxuICBjb21wYWN0OiBmYWxzZSxcbn07XG5cbkxpc3QucHJvcFR5cGVzID0ge1xuICBjb21wb25lbnQ6IFByb3BUeXBlcy5lbGVtZW50VHlwZSxcbiAgcm9sZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLFxuICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGNvbXBhY3Q6IFByb3BUeXBlcy5ib29sLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUmVhY3QubWVtbyhMaXN0KTtcbiJdfQ== */")),
  className: className
}, children);

List.defaultProps = {
  component: 'ul',
  role: '',
  children: [],
  className: undefined,
  compact: false
};
List.propTypes = {
  component: PropTypes.elementType,
  role: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  compact: PropTypes.bool
};
export default React.memo(List);
//# sourceMappingURL=List.js.map